import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import BrandTab from "./BrandTab";

function Brand () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <BrandTab />
      <Footer />
    </DashboardLayout>
  );
}

export default Brand;
